import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const AdminLogin: React.FC = () => {
  const { signInWithGoogle, user } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  React.useEffect(() => {
    if (user) {
      navigate('/admin/inventory');
    }
  }, [user, navigate]);

  const handleLogin = async () => {
    setError(null);
    try {
      await signInWithGoogle();
    } catch (err: any) {
      console.error(err);
      if (err.code === 'auth/configuration-not-found') {
        setError('Google Sign-In is not enabled. Please enable it in the Firebase Console and configure the OAuth consent screen.');
      } else if (err.code === 'auth/popup-closed-by-user') {
        setError('Sign-in cancelled.');
      } else {
        setError(`Failed to sign in: ${err.message} (${err.code})`);
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-light">
      <div className="bg-white p-8 rounded shadow-lg max-w-md w-full text-center">
        <h2 className="font-heading text-2xl mb-6">ADMIN ACCESS</h2>
        {error && (
          <div className="bg-red-50 text-red-600 p-3 mb-4 text-sm font-body border border-red-200">
            {error}
          </div>
        )}
        <button
          onClick={handleLogin}
          className="bg-brand-black text-white px-6 py-3 font-heading tracking-widest hover:bg-brand-gray transition-colors w-full"
        >
          SIGN IN WITH GOOGLE
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
